/*
 * @Author: your name
 * @Date: 2020-04-01 10:46:26
 * @LastEditTime: 2020-04-14 15:19:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cbh_front\src\libs\axios.js
 */

import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { Toast } from 'vant'

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl + '/'
    this.queue = {}
  }

  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        'appToken': sessionStorage.getItem('token') || ''
      }
    }
    return config
  }

  destroy (url) {
    delete this.queue[url]
  }

  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data } = res
      if (data.code === 200) {
        // Toast(data.msg)
        return data
      } else {
        if (data.code === 1001) {
          sessionStorage.removeItem('userInfo')
          store.commit('setUserInfo', {})
          sessionStorage.removeItem('token')
          store.commit('setToken', '')
          router.push('home')
        }
        if (data.code === 1002) {
          sessionStorage.removeItem('userInfo')
          store.commit('setUserInfo', {})
          sessionStorage.removeItem('token')
          store.commit('setToken', '')
          router.push('home')
        }
        setTimeout(() => {
          Toast(data.msg)
        }, 1000)
        return Promise.reject(data)
      }
    }, error => {
      console.log(error, 'error')
      const { code } = error.response.data
      // if (code === 10000) router.push('/login')
      this.destroy(url)
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options, { withCredentials: true })
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
